const ROW_STATUS_BY_ENGINE_STATE = Object.freeze({ slow: 'slow', offline: 'offline', confirming: 'confirming' });

const PREPARE_FAILED = 'Não foi possível preparar este arquivo para envio. Escolha o arquivo de novo.';

const BASE36 = 36;

const FULL_PROGRESS = 100;

const randomSuffix = () => Math.random().toString(BASE36).slice(2);

export const uploadRowOf = (file) => ({
    _localId: `upload-${Date.now()}-${randomSuffix()}`,
    _isPending: true,
    _uploadRow: true,
    file,
    name: file.name,
    fileSize: file.size,
    status: 'uploading',
    uploadProgress: 0,
});

export const isUploadRow = (doc) => Boolean(doc && doc._uploadRow);

export const patchOfState = (state) => {
    if (state.state === 'uploading')
        return { status: 'uploading', uploadProgress: state.percent, secondsLeft: state.secondsLeft };
    return ROW_STATUS_BY_ENGINE_STATE[state.state] ? { status: ROW_STATUS_BY_ENGINE_STATE[state.state] } : null;
};

export const patchOfSettled = (settled) => (settled.status === 'completed'
    ? { status: 'sent', uploadProgress: FULL_PROGRESS, documentId: settled.document && settled.document.id }
    : { status: 'failed', failureMessage: settled.message });

export const preparationFailed = () => ({ status: 'failed', failureMessage: PREPARE_FAILED });

export const patchRowsOf = (files, patch) => (rows) => rows.map(row => (files.includes(row.file) ? { ...row, ...patch } : row));

export const withoutArrived = (loadedDocuments) => (rows) => rows.filter(row => !(row.status === 'sent'
    && loadedDocuments.some(document => document.id === row.documentId)));

export const sentOf = (files, outcomes) => files
    .map((file, index) => ({ file, outcome: outcomes[index] }))
    .filter(({ outcome }) => outcome && outcome.status === 'completed' && outcome.document);
